<div class="monitor-layout">
    <mat-tab-group animationDuration="0ms" (selectedIndexChange)="onTabChange($event)"
        [selectedIndex]="activeTabSignal()" class="top-tabs">
        <mat-tab label="Facturas"></mat-tab>
        <mat-tab label="Pre-facturas"></mat-tab>
        <mat-tab label="Remisiones" disabled></mat-tab>
    </mat-tab-group>

    <div class="monitor-container">
        <!-- Nuevo Header Unificado: Atrás | Título | Metadata -->
        <div class="unified-header">
            <div class="header-left">
                <button mat-icon-button (click)="goBack()" class="circular-button back-button" matTooltip="Regresar">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <h1 class="page-title">
                    <mat-icon class="title-icon">description</mat-icon>
                    {{ currentTitle() }}
                </h1>
            </div>

            <!-- Metadata Widget (siempre visible en tab Facturas) -->
            @if (activeTabSignal() === 0 && avediMetadataSignal(); as meta) {
            <button mat-icon-button [matMenuTriggerFor]="metadataMenu" class="circular-button metadata-trigger"
                matTooltip="Ver estado de sincronización">
                <mat-icon [color]="getMetadataSyncStatus(meta)">cloud_sync</mat-icon>
            </button>
            <mat-menu #metadataMenu="matMenu" class="metadata-menu">
                <div class="metadata-dropdown" (click)="$event.stopPropagation()">
                    <div class="metadata-header">
                        <div class="header-row">
                            <span class="header-label">📝 Última Escritura Avedi</span>
                            <span class="header-value">
                                @if (getLatestSourceDate(meta.files_metadata); as latestDate) {
                                {{ latestDate | date : 'short' }}
                                } @else {
                                No disponible
                                }
                            </span>
                        </div>
                        <div class="header-row">
                            <span class="header-label">📥 Última Sincronización (Lectura)</span>
                            <span class="header-value sync-value">
                                @if (meta.last_system_sync && meta.last_system_sync !== 'No disponible') {
                                {{ meta.last_system_sync | date : 'short' }}
                                } @else {
                                Sin sincronización
                                }
                                @if (meta.last_sync; as ls) {
                                <span class="sync-badge sync-badge-{{ ls.status }}">{{ getSyncStatusLabel(ls.status) }}</span>
                                @if (ls.duration_seconds != null) {
                                <span class="sync-duration">({{ ls.duration_seconds }}s)</span>
                                }
                                }
                            </span>
                        </div>
                        @if (meta.last_sync?.summary; as summary) {
                        <div class="header-row sync-summary-row">
                            <span class="sync-summary">
                                {{ summary.created }} creadas · {{ summary.updated }} actualizadas · {{
                                summary.deleted }} eliminadas
                                @if (summary.skipped_rows > 0) {
                                · {{ summary.skipped_rows }} omitidas
                                }
                            </span>
                        </div>
                        }
                        @if (meta.last_sync?.status === 'ERROR' && meta.last_sync?.error) {
                        <div class="header-row sync-summary-row">
                            <span class="sync-error-detail">{{ meta.last_sync.error }}</span>
                        </div>
                        }
                    </div>
                    <div class="file-list">
                        @for (file of meta.files_metadata; track file.file_name) {
                        <div class="file-row">
                            <span class="file-name-text">{{ file.file_name }}</span>
                            <div class="file-info-right">
                                <span class="file-size-text">{{ (file.size_bytes / 1024).toFixed(0) }}KB</span>
                                @if (meta.last_system_sync && meta.last_system_sync !== 'No disponible' &&
                                file.last_modified_source > meta.last_system_sync) {
                                <mat-icon color="warn" class="file-status-icon">warning</mat-icon>
                                } @else if (!meta.last_system_sync || meta.last_system_sync === 'No disponible') {
                                <mat-icon color="accent" class="file-status-icon">info</mat-icon>
                                } @else {
                                <mat-icon color="primary" class="file-status-icon">check_circle</mat-icon>
                                }
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </mat-menu>
            } @else {
            <div class="metadata-spacer"></div>
            }
        </div>

        <!-- [MODIFICACIÓN] Usamos apiLoadingSignal (solo backend) para no ocultar la UI al filtrar localmente -->
        @if (apiLoadingSignal()) {
        <div class="spinner-container">
            <mat-progress-spinner mode="indeterminate" diameter="50"></mat-progress-spinner>
        </div>
        } @else {
        <!-- Filtros Colapsables Compactos -->
        <mat-expansion-panel class="filters-panel-compact" [expanded]="false">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <div style="display: flex; align-items: center; gap: 6px;">
                        <mat-icon>filter_list</mat-icon>
                        <span>Filtros</span>
                        <!-- Spinner local alineado inmediatamente después de "Filtros" -->
                        @if (isLoadingSignal()) {
                        <mat-progress-spinner mode="indeterminate" diameter="20" class="filter-spinner"
                            style="margin-left: 2px;"></mat-progress-spinner>
                        }
                    </div>
                </mat-panel-title>
                <mat-panel-description>
                    <span>{{ totalFacturasFiltradasSignal() }} resultados</span>
                </mat-panel-description>
            </mat-expansion-panel-header>

            <form [formGroup]="filtroForm" class="filtros-form-compact">
                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Buscar</mat-label>
                    <input matInput formControlName="textoGeneral" [readonly]="false" />
                    <mat-icon matPrefix>search</mat-icon>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Emisor</mat-label>
                    <input type="text" matInput formControlName="emisor" [matAutocomplete]="autoEmisor"
                        [readonly]="isLoadingSignal()" />
                    <mat-autocomplete #autoEmisor="matAutocomplete">
                        @for (option of filteredEmisores$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>Cliente</mat-label>
                    <input type="text" matInput formControlName="cliente" [matAutocomplete]="autoCliente"
                        [readonly]="isLoadingSignal()" />
                    <mat-autocomplete #autoCliente="matAutocomplete">
                        @for (option of filteredClientes$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field" subscriptSizing="dynamic">
                    <mat-label>RFC</mat-label>
                    <input type="text" matInput formControlName="rfc" [matAutocomplete]="autoRfc"
                        [readonly]="isLoadingSignal()" />
                    <mat-autocomplete #autoRfc="matAutocomplete">
                        @for (option of filteredRfcs$ | async; track option) {
                        <mat-option [value]="option">{{ option }}</mat-option>
                        }
                    </mat-autocomplete>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field date-field" subscriptSizing="dynamic">
                    <mat-label>Fechas</mat-label>
                    <mat-date-range-input [formGroup]="rangoFechasFormGroup" [rangePicker]="pickerFechas">
                        <input matStartDate formControlName="inicio" placeholder="Desde"
                            (ngModelChange)="onRangoFechaInicioChange()" [readonly]="isLoadingSignal()" />
                        <input matEndDate formControlName="fin" placeholder="Hasta"
                            (ngModelChange)="onRangoFechaFinChange()" [readonly]="isLoadingSignal()" />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="pickerFechas"
                        [disabled]="isLoadingSignal()"></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerFechas></mat-date-range-picker>
                </mat-form-field>

                <mat-form-field appearance="outline" class="dense-field status-field" subscriptSizing="dynamic">
                    <mat-label>Estatus</mat-label>
                    <mat-select formControlName="estatus" [disabled]="isLoadingSignal()">
                        <mat-option value="">Todos</mat-option>
                        @for (est of estatusDisponibles(); track est) {
                        <mat-option [value]="est">{{ est }}</mat-option>
                        }
                    </mat-select>
                </mat-form-field>

                <div class="filter-actions">
                    <button mat-icon-button color="primary" (click)="limpiarFiltros()" type="button"
                        matTooltip="Limpiar Filtros" [disabled]="isLoadingSignal()">
                        <mat-icon>filter_alt_off</mat-icon>
                    </button>
                    <button mat-icon-button color="accent" (click)="forzarRefrescoCompleto()" type="button"
                        matTooltip="Refrescar" [disabled]="isLoadingSignal()">
                        <mat-icon>refresh</mat-icon>
                    </button>
                </div>
            </form>
        </mat-expansion-panel>

        <div class="controles-superiores">

            <mat-checkbox (change)="onSelectAllFiltradasChange($event)" [checked]="todasSeleccionadasSignal()"
                [disabled]="totalFacturasFiltradasSignal() === 0 || isLoadingSignal()"
                matTooltip="Seleccionar/Deseleccionar todas las facturas que coinciden con los filtros (en todas las páginas)">
                Sel. Todas {{ totalFacturasFiltradasSignal() }}
            </mat-checkbox>

            <mat-form-field appearance="outline" class="dense-field select-cambio-estatus" subscriptSizing="dynamic">
                <mat-label>Cambiar Estatus</mat-label>
                <mat-select [(ngModel)]="estatusSeleccionadoParaCambio" [disabled]="isLoadingSignal()">
                    @for (est of estatusDisponibles(); track est) {
                    <mat-option [value]="est">{{ est }}</mat-option>
                    }
                </mat-select>
            </mat-form-field>

            <button mat-icon-button color="primary" (click)="aplicarCambioDeEstatus()"
                [disabled]="!estatusSeleccionadoParaCambio || invoiceMonitorService.getFacturasSeleccionadasIds().length === 0 || isLoadingSignal() || isUpdatingStatusSignal()"
                matTooltip="Guardar Cambios">
                @if (!isUpdatingStatusSignal()) {
                <mat-icon>save</mat-icon>
                } @else {
                <mat-progress-spinner mode="indeterminate" diameter="24"></mat-progress-spinner>
                }
            </button>

            <span class="spacer"></span>

            <button mat-stroked-button (click)="openUploadStatusDialog()"
                [disabled]="isLoadingSignal() || isUpdatingStatusSignal()"
                matTooltip="Actualizar estatus masivamente desde una plantilla Excel" style="font-size: 12px;">
                <mat-icon style="color: #1D6F42;">description</mat-icon>
                <span>Cargar Plantilla</span>
            </button>

            <button mat-stroked-button (click)="exportarExcel()"
                [disabled]="isLoadingSignal() || totalFacturasFiltradasSignal() === 0"
                matTooltip="Exportar a Excel las facturas filtradas" style="font-size: 12px;">
                <mat-icon style="color: #1D6F42;">table_view</mat-icon>
                <span>Exportar Excel</span>
            </button>

            <mat-paginator [length]="totalFacturasFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
                [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
                aria-label="Seleccionar página de facturas" (page)="pageEventSignal.set($event)"
                [disabled]="isLoadingSignal()" showFirstLastButtons></mat-paginator>
        </div>

        @if (facturasPaginadasSignal() && facturasPaginadasSignal()!.length > 0) {
        <mat-accordion [multi]="false" class="facturas-accordion">
            @for (factura of facturasPaginadasSignal(); track factura.id) {
            <mat-expansion-panel [disabled]="isLoadingSignal()">
                <mat-expansion-panel-header>
                    <mat-panel-title class="panel-title-container">
                        <mat-checkbox [checked]="factura.seleccionada"
                            (change)="onFacturaSelectionChange(factura.id, $event)" (click)="$event.stopPropagation()"
                            class="panel-checkbox" [disabled]="isLoadingSignal()"></mat-checkbox>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Serie-Folio:</span>
                                <span class="info-value folio">{{ factura.serie }}-{{ factura.folio }}</span>
                                <button mat-icon-button class="copy-button"
                                    [cdkCopyToClipboard]="factura.serie + '-' + factura.folio"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(factura.serie + '-' + factura.folio)"
                                    matTooltip="Copiar Folio Completo">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>

                            <!-- CORRECCIÓN VISUALIZACIÓN ORDEN -->
                            <div class="info-item">
                                <span class="info-label">Orden:</span>
                                @if (factura.ordenSurtimientoId || factura.ordenSurtimiento) {
                                <span class="info-value orden-surtimiento linked"
                                    [matTooltip]="'ID: ' + (factura.ordenSurtimiento?.id || factura.ordenSurtimientoId)">
                                    <mat-icon class="link-icon">link</mat-icon>
                                    {{
                                    factura.ordenSurtimiento?.folioOrden ||
                                    factura.folioOrden ||
                                    'Ver
                                    Detalle'
                                    }}
                                </span>
                                <button mat-icon-button class="copy-button"
                                    [cdkCopyToClipboard]="factura.ordenSurtimiento?.folioOrden || factura.folioOrden || ''"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(factura.ordenSurtimiento?.folioOrden || factura.folioOrden || '')"
                                    matTooltip="Copiar Folio Orden">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                                } @else {
                                <span class="info-value orden-surtimiento no-vinculada">Sin Orden</span>
                                }
                            </div>
                        </div>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Emisor:</span>
                                <span class="info-value cliente" [matTooltip]="factura.emisorNombre">
                                    {{ factura.emisorNombre | slice : 0 : 30 }}{{ factura.emisorNombre.length > 30 ?
                                    '...' : '' }}
                                </span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">RFC Emisor:</span>
                                <span class="info-value rfc">{{ factura.emisorRFC }}</span>
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="factura.emisorRFC"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(factura.emisorRFC)"
                                    matTooltip="Copiar RFC Emisor">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="factura-info-group">
                            <div class="info-item">
                                <span class="info-label">Cliente (Receptor):</span>
                                <span class="info-value cliente" [matTooltip]="factura.receptorNombre">
                                    {{ factura.receptorNombre | slice : 0 : 30 }}{{ factura.receptorNombre.length > 30 ?
                                    '...' : '' }}
                                </span>
                                <button mat-icon-button class="copy-button"
                                    [cdkCopyToClipboard]="factura.receptorNombre"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(factura.receptorNombre)"
                                    matTooltip="Copiar Nombre Cliente">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                            <div class="info-item">
                                <span class="info-label">RFC Receptor:</span>
                                <span class="info-value rfc">{{ factura.receptorRFC }}</span>
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="factura.receptorRFC"
                                    (click)="$event.stopPropagation(); onCopyToClipboard(factura.receptorRFC)"
                                    matTooltip="Copiar RFC Receptor">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </div>
                        </div>

                        <div class="factura-info-group align-right">
                            <div class="info-item">
                                <span class="info-label">Total:</span>
                                <span class="info-value total">{{ factura.total | currency : factura.moneda : 'symbol' :
                                    '1.2-2' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">Emisión:</span>
                                <span class="info-value fecha">{{ factura.fechaEmision | date : 'dd/MM/yyyy' }}</span>
                            </div>
                        </div>

                        <div class="factura-info-group status-group">
                            <span class="factura-info estatus status-{{ factura.estatus.split(' ').join('-') }}"
                                [ngClass]="getEstatusClass(factura.estatus)"
                                [style.background]="getStatusColor(factura.estatus)">
                                {{ getStatusName(factura.estatus) }}
                            </span>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div class="factura-detalle">
                    <div class="detalle-grid">
                        <div class="detalle-seccion">
                            <h4>Información General</h4>
                            <p>
                                <strong>UUID:</strong>
                                <span>{{ factura.uuid }}</span>

                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="factura.uuid"
                                    (click)="$event.stopPropagation(); onCopyToClipboard('UUID')"
                                    matTooltip="Copiar UUID">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </p>
                            <p>
                                <strong>Tipo:</strong>
                                <span>({{ factura.tipo_comprobante }}) - Ingreso</span>
                            </p>
                            <p>
                                <strong>Uso CFDI:</strong>
                                <span>({{ factura.usoCFDI }}) - {{ getUsoCFDIDescripcion(factura.usoCFDI!) }}</span>
                            </p>
                        </div>
                        <div class="detalle-seccion">
                            <h4>Información de Pago</h4>
                            <p>
                                <strong>Método Pago:</strong>
                                <span>({{ factura.metodoPago }}) - {{ getMetodoPagoDescripcion(factura.metodoPago!)
                                    }}</span>
                            </p>
                            <p>
                                <strong>Forma Pago:</strong>
                                <span>({{ factura.formaPago }}) - Por definir</span>
                            </p>
                            @if (factura.descuento) {
                            <p>
                                <strong>Descuento:</strong>
                                <span>{{ factura.descuento | currency : 'MXN' : 'symbol' }}</span>
                            </p>
                            }
                        </div>
                        <div class="detalle-seccion">
                            <h4>Emisor</h4>
                            <p>
                                <strong>Nombre:</strong>
                                <span>{{ factura.emisorNombre }}</span>
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="factura.emisorNombre"
                                    (click)="$event.stopPropagation(); onCopyToClipboard('Emisor')"
                                    matTooltip="Copiar Nombre Emisor">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </p>
                            <p>
                                <strong>RFC:</strong>
                                <span>{{ factura.emisorRFC }}</span>
                                <button mat-icon-button class="copy-button" [cdkCopyToClipboard]="factura.emisorRFC"
                                    (click)="$event.stopPropagation(); onCopyToClipboard('RFC Emisor')"
                                    matTooltip="Copiar RFC Emisor">
                                    <mat-icon>content_copy</mat-icon>
                                </button>
                            </p>
                            <p>
                                <strong>Régimen Fiscal:</strong>
                                <span>({{ factura.regimenFiscalEmisor }}) - {{
                                    getRegimenFiscalDescripcion(factura.regimenFiscalEmisor!) }}</span>
                            </p>
                        </div>
                        <div class="detalle-seccion">
                            <h4>Fechas Clave</h4>
                            <p>
                                <strong>Emisión:</strong>
                                <span>
                                    {{
                                    factura.fechaEmision
                                    | date
                                    : 'dd/MM/yyyy
                                    HH:mm'
                                    }}
                                </span>
                            </p>
                            <p>
                                <strong>Timbrado:</strong>
                                <span>
                                    {{
                                    factura.fechaTimbrado
                                    | date
                                    : 'dd/MM/yyyy
                                    HH:mm'
                                    }}
                                </span>
                            </p>
                            @if (factura.fechaVencimiento) {
                            <p>
                                <strong>Vencimiento:</strong>
                                <span>{{ factura.fechaVencimiento | date : 'dd/MM/yyyy' }}</span>
                            </p>
                            } @if (factura.fecha_cancelacion) {
                            <p>
                                <strong>Cancelación:</strong>
                                <span>{{ factura.fecha_cancelacion | date : 'dd/MM/yyyy HH:mm' }}</span>
                            </p>
                            }
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="status-history-container">
                        <h4>📋 Historial de Cambios</h4>
                        @if(factura.statusHistory && factura.statusHistory.length > 0) {
                        <div class="history-scroll-container">
                            @for(history of factura.statusHistory; track history.fecha) {
                            <div class="history-card">
                                <div class="history-card-status">{{ getStatusName(history.estatus) }}</div>
                                <div class="history-card-date">
                                    <mat-icon>schedule</mat-icon>
                                    {{ history.fecha | date : 'dd/MM/yy HH:mm' }}
                                </div>
                                @if (history.observacion) {
                                <div class="history-card-obs">{{ history.observacion }}</div>
                                }
                            </div>
                            }
                        </div>
                        } @else {
                        <p class="no-history">Sin historial</p>
                        }
                    </div>
                </div>
            </mat-expansion-panel>
            }
        </mat-accordion>
        } @else if (!isLoadingSignal() && totalFacturasFiltradasSignal() === 0) {
        <div class="no-facturas">
            <mat-icon>inbox</mat-icon>
            <p>No se encontraron facturas con los filtros aplicados o no hay facturas disponibles.</p>
        </div>
        }

        <!-- Paginador Inferior -->
        @if (!isLoadingSignal() && totalFacturasFiltradasSignal() > pageEventSignal().pageSize) {
        <div class="bottom-paginator">
            <mat-paginator [length]="totalFacturasFiltradasSignal()" [pageSize]="pageEventSignal().pageSize"
                [pageIndex]="pageEventSignal().pageIndex" [pageSizeOptions]="[20, 40, 60, 80]"
                aria-label="Seleccionar página de facturas" (page)="pageEventSignal.set($event)"
                [disabled]="isLoadingSignal()" showFirstLastButtons></mat-paginator>
        </div>
        }
        }